import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, Alert, CircularProgress, TextField } from '@mui/material';
import { getFirestore, doc, setDoc } from 'firebase/firestore';

const QuickAdminSetup = () => {
  const [email, setEmail] = useState('kihembowilb@gmail.com');
  const [userId, setUserId] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleMakeAdmin = async () => {
    if (!email || !userId) {
      setError('Both email and user ID are required');
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const db = getFirestore();
      
      // Direct write to the user document with the specified ID
      await setDoc(doc(db, 'users', userId), {
        email: email,
        displayName: email.split('@')[0],
        roles: {
          user: true,
          admin: true,
          artist: true,
          superadmin: true
        },
        createdAt: new Date(),
        updatedAt: new Date()
      }, { merge: true });
      
      setSuccess(true);
      console.log(`Successfully made ${email} a super admin with ID: ${userId}`);
    } catch (err) {
      console.error('Error making admin:', err);
      setError(err.message || 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom align="center">
          Quick Admin Setup
        </Typography>
        
        <Typography variant="body1" paragraph>
          This tool directly sets up admin privileges using the user's ID and email.
        </Typography>
        
        <TextField
          fullWidth
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          disabled={loading}
        />
        
        <TextField
          fullWidth
          label="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          margin="normal"
          disabled={loading}
          helperText="Enter the Firebase Auth UID for this user"
        />
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Button 
            variant="contained" 
            color="primary"
            disabled={loading || !email || !userId}
            onClick={handleMakeAdmin}
          >
            {loading ? <CircularProgress size={24} /> : 'Make Super Admin'}
          </Button>
        </Box>
        
        {success && (
          <Alert severity="success" sx={{ mt: 3 }}>
            Successfully made {email} a super admin!
          </Alert>
        )}
        
        {error && (
          <Alert severity="error" sx={{ mt: 3 }}>
            {error}
          </Alert>
        )}
      </Paper>
      
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          How to Find Your User ID
        </Typography>
        
        <Typography variant="body2" paragraph>
          To find your Firebase User ID:
        </Typography>
        
        <ol>
          <li>Sign in to your account</li>
          <li>Open browser developer console (F12)</li>
          <li>Run this command: <code>console.log(firebase.auth().currentUser.uid)</code></li>
          <li>Copy the ID that appears and paste it above</li>
        </ol>
        
        <Typography variant="body2" sx={{ mt: 2 }}>
          After becoming an admin, you'll be able to access the admin panel at <code>/marketplace/admin/tools</code>
        </Typography>
      </Paper>
    </Box>
  );
};

export default QuickAdminSetup;
